module.exports = __webpack_public_path__ + "static/HTTPDIAGRAM-cb2517a182d1981edf0ad74d0e8404e2.png";